<template>
    <modal dialog="modal-lg" class="dark-top" :footer="false" :headerStyle="{'background-color': currentIntegration.color.main}">
        <div slot="title">
            <h2>GetYourGuide</h2>
        </div>

        <div slot="body">
            <!-- Top area -->
            <top-area :integration="currentIntegration" >
                <div class="bg-blue-pale p-2 mt-3">
                    Please note that you need to have active products on GYG in order to connect with Pluralo. Log into your <a class="darkest underlined" href="https://supplier.getyourguide.com/" target="_blank">Supply Portal</a>.  Don’t have an account? <a class="darkest underlined" href="https://supplier.getyourguide.com/en/register" target="_blank">Sign Up here</a>.
                </div>
            </top-area>

            <!-- Lower area -->
            <div class="px-5 pt-4 pb-4">
                <!-- Steps -->
                <div>
                    <div class="d-flex stepRow">
                        <div class="stepNumber d-flex border-dark align-items-center justify-content-center">1</div>

                        <div class="stepText d-flex align-items-center flex-grow-1">
                            <div>
                                Set your commissions and payment protocol with GetYourGuide.
                            </div>
                        </div>

                        <div class="stepButton d-flex">
                            <loader v-if="creatingProtocol"></loader>
                            <button v-else-if="!isIntegrated" type="button" class="btn tertiary w-100" @click="crateProtocol()">Create Protocol</button>
                            <button v-else-if="isIntegrated" type="button" class="btn tertiary w-100"><i class="fas fa-check color-3"></i> Created</button>
                        </div>
                    </div>

                    <div class="d-flex stepRow">
                        <div class="stepNumber d-flex border-dark align-items-center justify-content-center">2</div>

                        <div class="stepText d-flex align-items-center flex-grow-1">
                            <div>
                                Log into your <a class="color-1 underlined bold" href="https://supplier.getyourguide.com/" target="_blank">Supply Portal</a> and using the table bellow connect the products ID.<br>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Product list holder -->
                <div class="productListHolder mb-3">
                    <div v-if="getLoadingProducts" class="p-4 text-center">
                        <loader></loader>
                    </div>
                    <div v-else>
                        <!-- Product list -->
                        <list class="" :header="productListHeader" :body="productListBody" :rows="products" ></list>
                    </div>
                </div>

                <bottom-area
                    :isIntegrated="isIntegrated"
                    :showSaveBtn="false"
                    @disableIntegration="deactivateIntegration()"
                    @close="closeModal()"
                >
                    <button v-if="isIntegrated" type="button" class="btn blue" @click="openAgentDetails()">Open GYG Agent Details</button>
                </bottom-area>
            </div>
        </div>
    </modal>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    
    import Modal from '@/tools/modal/Modal'
    import howToConnect from '@/components/otas/getYourGuide/howToConnect/howToConnect'
    import List from '@/tools/list/baseList'
    import Loader from '@/tools/loaders/loader1'
    import topArea from './popupParts/topArea'
    import bottomArea from './popupParts/bottomArea'


    export default {
        data() {
            return {
                creatingProtocol: false,
                isDeactivating: false,
            }
        },
        created() {
            this.initProducts();
        },
        computed: {
            ...mapGetters([
                'getProducts',
                'getOTAs',
                'getAgents',
                'getLoadingProducts',
                'getSelectedIntegration'
            ]),
            currentIntegration() {
                return this.getSelectedIntegration;
            },
            gygOta() {
                return this.getOTAs.find(ota => ota.id == 1);
            },
            products() {
                return this.getProducts;
            },
            productListHeader() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    list: {
                        id: 'ID',
                        name: 'Product Name',
                    },
                };
            },
            productListBody() {
                return {
                    selection: {
                        active: false,
                        event: (event) => {}
                    },
                    customCells: {
                        id: this.formatId,
                        name: this.formatName,
                    },
                    customRowEvent: null,
                }
            },
            isIntegrated() {
                return typeof this.getAgents.find(agent => {
                    return agent.isOTA && agent.channelType == 202 && agent.protocolStatus == 1;
                }) == "object";
            }
        },
        methods: {
            ...mapActions([
                'closeModal',
                'connectToGetYourGuide',
                'setSelectedPerson',
                'openModal',
                'openIntegrationSettings',
                'requestDeactivateGYG',
                'initAgents',
                'downloadSupplierIntegrations',
                'initProducts'
            ]),
            openAgentDetails() {
                this.openIntegrationSettings(this.currentIntegration);
            },
            formatId(item) {
                return item.externalBookingSystemCode;
            },
            formatName(item) {
                return '<div class="bold">' + item.name + '</div>';
            },
            crateProtocol() {
                this.creatingProtocol = true;
                this.connectToGetYourGuide().then(response => {
                    this.creatingProtocol = false;

                    if (response && response.status == 200) {
                        this.setSelectedPerson(response.data);

                        // Set modal AgentView selected tab
                        const currentTime = new Date().getTime();
                        const expires = new Date(currentTime + 15 * 60000);
                        const value = '#commissions';
                        localStorage.setItem(`vue-tabs-component-pluralo.cache.${window.location.host}${window.location.pathname}`, JSON.stringify({ value, expires }));

                        this.openModal({
                            name: 'AgentView',
                            callback: () => {
                                setTimeout(() => {
                                    this.downloadSupplierIntegrations();
                                }, 10);
                            }
                        });
                    }
                }).catch(err => {
                    this.creatingProtocol = false;
                })
            },
            deactivateIntegration() {
                this.isDeactivating = true;
                this.requestDeactivateGYG().then(response => {
                    this.isDeactivating = false;
                    this.initAgents();
                    this.closeModal();
                }).catch(err => {
                    this.isDeactivating = false;
                    this.closeModal();
                })
            }
        },
        components: {
            topArea,
            bottomArea,
            List,
            Loader,
            Modal,
            howToConnect
        }
    }
</script>

<style lang="scss" scoped>
    .stepRow {
        margin-bottom: 2em;
        
        .stepNumber {
            font-size: 16px;
            border-radius: 9999px;
            width: 30px;
            max-width: 30px;
            min-width: 30px;
            text-align: center;
            height: 30px;
            padding-top: 1px;
            font-weight: bold;
            margin-right: 1em;
        }
        
        .stepButton {
            white-space: nowrap;
            width: 150px;
        }
    }

    .productListHolder {
        height: 30vh;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// gygIntegrate.vue?cd6044d8